import { v4 as uuidv4 } from 'uuid';
import { ArrayUtil, ObjectUtil, StringUtil } from 'src/utils';

interface AssetListItemDTO {
  id: string;
  assetName: string;
  pos: string;
  code: string;
  activationCode: string;
  reseller: string;
  quantity: string;
  disabled: boolean;
}
const AssetListItemDTO = {
  create: (initValues?: Partial<AssetListItemDTO>): AssetListItemDTO => {
    const defaults: AssetListItemDTO = {
      id: '',
      assetName: '',
      pos: '',
      code: '',
      activationCode: '',
      reseller: '',
      quantity: '',
      disabled: false,
    };
    const fixedInitValues: Partial<AssetListItemDTO> = initValues != null
      ? {
        id: StringUtil.IsNullOrEmpty(initValues.id) ? uuidv4() : initValues.id,
      }
      : {};
    return { ...defaults, ...initValues, ...fixedInitValues };
  },
};

export default AssetListItemDTO;
